import { UserAgent } from "@bounce/util"

import type { WebIntegration } from "../../types"

export const UserAgentIntegration: WebIntegration = {
  name: "User Agent",
  type: "before",
  version: "1.0.0",

  isLoaded: () => true,
  load: () => Promise.resolve(),
  identify: ctx => {
    ctx.event.traits = Object.assign({}, ctx.event.traits)

    const parsedUA = UserAgent.get()
    if (parsedUA) {
      ctx.event.traits.browser_name = parsedUA.browser.name
      ctx.event.traits.browser_version = parsedUA.browser.version
      ctx.event.traits.user_agent = parsedUA.ua
    }

    return ctx
  },
}
